import emptySplitApi from "../utils/rtk";
import { CommonBody, PaymentResponseType } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};

type GetPaymentsResponse = {
  length: number;
  start: number;
  response_object: PaymentResponseType[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};
export type GetDashboardResponse = {
  active: number;
  completed: number;
  in_progress: number;
  inactive: number;
  revenue: number;
};
export type GetAgentRevenue = {
  basic_revenue_sum: number;
  basic_salary: number;
  benefits: number;
  bonus: number;
  commission_sum: number;
  target: number;
  total_salary: number;
};

export const paymentsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPayments: builder.mutation<
      CommonResponseType & { data: GetPaymentsResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getAllPayments,
        method: "POST",
        body,
      }),
    }),

    paymentDetail: builder.query<
      CommonResponseType & { data: PaymentResponseType | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.paymentById}${id}/`,
        method: "GET",
      }),
    }),

    salariedAgentPayments: builder.mutation<
      CommonResponseType & { data: GetPaymentsResponse },
      { body: CommonBody; id: number | null }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.salariedAgentPayments}${id}/`,
        method: "POST",
        body,
      }),
    }),
    agentRevenue: builder.mutation<
      CommonResponseType & { data: GetAgentRevenue },
      { body: CommonBody; id: number | null }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.agentRevenue}${id}/`,
        method: "POST",
        body,
      }),
    }),
    userPayments: builder.mutation<
      CommonResponseType & { data: GetPaymentsResponse },
      { body: CommonBody; id: number | null }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.userPayments}${id}/`,
        method: "POST",
        body,
      }),
    }),
    partnerPayments: builder.mutation<
      CommonResponseType & { data: GetPaymentsResponse },
      { body: CommonBody; id: number | null }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.partnerPayments}${id}/`,
        method: "POST",
        body,
      }),
    }),

    getDashboard: builder.mutation<
      CommonResponseType & { data: GetDashboardResponse },
      CommonBody
    >({
      query: (body) => ({
        url: `${END_POINTS.dashboard}`,
        method: "POST",
        body,
      }),
    }),
    paymentStatus: builder.mutation<
      CommonResponseType & { data: GetDashboardResponse },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.paymentStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    exportPayments: builder.mutation<any, CommonBody>({
      query: (body) => ({
        url: `${END_POINTS.exportPayments}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllPaymentsMutation,
  useLazyPaymentDetailQuery,
  useAgentRevenueMutation,
  useUserPaymentsMutation,
  usePartnerPaymentsMutation,
  useGetDashboardMutation,
  useSalariedAgentPaymentsMutation,
  usePaymentStatusMutation,
  useExportPaymentsMutation,
} = paymentsApi;
